import z from 'zod';

export type ShoppingCartState = 'Live' | 'Approved' | 'Review';

export const ShoppingCartStateSchema: z.ZodType<ShoppingCartState> = z.enum([
	'Live',
	'Approved',
	'Review',
]);
